import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'src/app/models/message';
import { Survey } from 'src/app/models/survey/survey';
import { SurveyService } from 'src/app/services/survey/survey.service';
import { StatusService } from 'src/app/services/survey/status.service';

import { urlEndPoint } from 'src/app/common';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';
import { Status } from 'src/app/models/survey/status';

@Component({
  selector: 'app-surveys-form',
  templateUrl: './surveys-form.component.html',
  styleUrls: ['./surveys-form.component.scss']
})
export class SurveysFormComponent implements OnInit {



  form: FormGroup;
  sv: Survey = null;
  status: Status = null;

  edit: boolean = false;

  isUploadDir: boolean = false;
  filename: string = null;
  URL: string = urlEndPoint;
  uploatedFile: File;

  msg: Message = { message: null, status: null };
  hiddenMsg: boolean = true;

  constructor(
    private router: Router,
    private svS: SurveyService,
    private statusS: StatusService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private uploadS: UploadfileService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getSurvey(params);
    this.getAllStatus();
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idcreator: [null],
      idstatus: [null],
      name: ['', Validators.required],
      title: ['', Validators.required],
      startdate: [],
      lastaccess: [],
      enddate: [],
      url: [],
      logo: [],
      isOpened: [],
      isCompleted: [],
      createdAt: [],
      updatedAt: [],
      status: []
    })
  }

  getSurvey(params: any) {
    this.svS.getOne(params.id)
      .subscribe(
        res => {
          this.sv = res['data'];
          this.verifiedImgDirectory();
          this.loadData();
          this.edit = true;
        },
        err => console.error(err)
      );
  }

  getAllStatus() {
    this.statusS.getAll()
      .subscribe(
        res => {
          this.status = res['data'];
        },
        err => console.error(err)
      );
  }

  loadData() {
    this.form.reset(this.sv);
  }

  cancel() {
    this.routingToList();
  }

  validateForm() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.onUpload();
    }
  }

  onUpload() {
    if (this.uploatedFile != null) {
      let formData = new FormData();
      formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
      // Call service
      this.uploadS.uploadFile(formData).subscribe((res) => {
        this.filename = res['filename'];
        this.update(this.form.value.id, this.form.value);
        this.routingToList();
      });
    } else {
      this.update(this.form.value.id, this.form.value);
      this.routingToList();
    }
  }

  routingToList() {
    this.router.navigate(['/encuesta/encuestas/list']);
  }

  update(id: string, sv: Survey) {
    delete sv.id;
    if (this.filename) {
      sv.logo = '/uploads/' + this.filename;
    }
    this.svS.update(id, sv)
      .subscribe(
        res => {
          this.msg.message = res['message'];
          this.msg.status = res['status'];
          this.hiddenMsg = false;
        },
        err => { console.error(err) }
      );
  }

  verifiedImgDirectory() {
    if (this.sv.logo != null) {
      (this.sv.logo.substring(1, 7) === 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

}
